export default __webpack_public_path__ + "static/media/regaloicon.2e00f4df.png";